(function () {
    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        timezone(
            module.exports,
            require('moment-timezone'),
            Intl
        );

    } else {
        RivalIQ.module('utils.timezone');

        timezone(
            RivalIQ.utils.timezone,
            window.moment,
            window.Intl
        );
    }

    function timezone(utils, moment, Intl) {

        utils.getDisplayName = function (timeZone, datetime) {
            if (datetime === null || typeof datetime === 'undefined') {
                datetime = new Date();
            }
            const zoneAbbrev = moment.tz(datetime, timeZone).zoneName();
            return timeZone ? `${timeZone.replace(/_/g, ' ')} (${zoneAbbrev})` : 'Unknown';
        };

        utils.getTimeZoneOffsetMinutes = function (timeZone, datetime) {
            return -1 * moment.tz.zone(timeZone).utcOffset(datetime);
        };

        utils.convertUtcDateToTz = function (utcDate, timezone) {
            if (!moment.isMoment(utcDate) || !utcDate.isUtc()) {
                utcDate = moment.utc(utcDate);
            }
            timezone = timezone || 'UTC';
            return utils.getDateInTimezone(timezone, utcDate);
        };

        utils.getTimezoneAbbreviation = function (timeZone, datetime) {
            return moment.tz(datetime, timeZone).zoneName();
        };

        utils.getDateInTimezone = function (timeZone, datetime) {
            const datetimeMoment = moment.utc(datetime);
            return datetimeMoment.add(utils.getTimeZoneOffsetMinutes(timeZone, datetimeMoment), 'minutes');
        };

        utils.guessTimezone = function () {
            try {
                return moment.tz.guess();
            } catch (ex) {
                // press on, we don't want the page to explode if moment.guess fails.
            }
        };

        utils.getClientTimezoneString = function () {
            // Try the right way (but will fail in IE)
            // check the moment timezone guess, but this can also fail
            // finally fall back to UTC
            const IntlTimeZone = (Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null);
            return IntlTimeZone || utils.guessTimezone() || 'UTC';
        };

        utils.getDayOffsetBetweenUtcAndTimezone = function (timeZone, datetime) {

            let dayOffset = 0;

            const datetimeTz = utils.getDateInTimezone(timeZone, datetime);
            if (moment.utc(datetime).isAfter(datetimeTz, 'day')) {
                dayOffset = 1;
            } else if (moment.utc(datetime).isBefore(datetimeTz, 'day')) {
                dayOffset = -1;
            }

            return dayOffset;
        };

        // formats the given hour in 12 or 24-hour formatting with timezone abbreviation
        utils.formatHour = function (hour, tz) {

            if (!tz) {
                tz = utils.getClientTimezoneString();
            }

            const dateWithoutSecond = new Date(0);
            dateWithoutSecond.setHours(hour);
            // guess whether we should use 12-hour or 24-hour time formatting
            const localizedTime = dateWithoutSecond.toLocaleTimeString(navigator.language, {
                hour: '2-digit',
                minute: '2-digit'
            });
            const timezone = moment().tz(tz);
            // fall back to js date + navigator.language if moment.guess fails
            const abbreviatedTimeZone = timezone ? timezone.format('z') : (new Date().toLocaleTimeString(navigator.language, {
                timeZoneName: 'short'
            }).split(' ')[2]);
            return `${localizedTime} (${abbreviatedTimeZone})`;
        };
    }
})();
